import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const u = await login(email, password);
      toast.success("Connexion réussie");
      navigate(u.role === "admin" ? "/admin" : u.role === "client" ? "/" : "/owner");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 lr-gradient-dark relative overflow-hidden">
        <div className="absolute inset-0 lr-grain opacity-50" />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white">
          <Link to="/" className="self-start inline-block rounded-2xl bg-white p-3">
            <BrandLogo className="h-14" />
          </Link>
          <div>
            <h2 className="font-display text-4xl font-extrabold leading-tight">Gérez votre flotte.<br />Trouvez vos clients.</h2>
            <p className="mt-4 text-slate-300 max-w-md">Connectez-vous à votre espace loueur pour gérer vos véhicules, vos disponibilités et vos demandes de location.</p>
          </div>
          <div className="flex gap-2">
            <span className="h-3 w-8 rounded-sm" style={{ background: "#C1272D" }} />
            <span className="h-3 w-8 rounded-sm" style={{ background: "#006233" }} />
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 text-center">
            <Link to="/" className="inline-block"><BrandLogo className="h-14" /></Link>
          </div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900">Connexion Pro</h1>
          <p className="text-slate-500 mt-2">Accédez à votre espace loueur.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
              <input required type="email" data-testid="owner-login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 w-full rounded-md border border-input px-3 text-sm" placeholder="vous@agence.ma" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Mot de passe</label>
              <input required type="password" data-testid="owner-login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 w-full rounded-md border border-input px-3 text-sm" placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="owner-login-submit-btn" className="w-full h-11 text-white font-semibold" style={{ background: "#006233" }}>
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Se connecter"}
            </Button>
          </form>
          <p className="mt-6 text-sm text-slate-500 text-center">
            Pas encore de compte ? <Link to="/register" className="font-semibold" style={{ color: "#006233" }}>Publier mon agence</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
